<template>
  <div id="MaterialBase">
    <v-skeleton-loader
      v-if="loading"
      type="heading, divider"
    />
    <v-toolbar v-else tile>
      <v-toolbar-title class="headline font-weight-bold">
        <v-chip :to="{ name: 'Materials' }" color="primary" dark label>
          <v-icon small left>{{ material.icon }}</v-icon>
          <span class="font-weight-medium">{{ material.id }}</span>
        </v-chip>
        {{ material.name }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-icon v-if="material.customersupplied" class="mx-2">
          {{ material.customersuppliedIcon }}
        </v-icon>
        <ArchiveForm :instance="material" />
        <MaterialForm :is-edit="true" :instance="material"/>
        <v-btn icon @click="saveJson"><v-icon>cloud_download</v-icon></v-btn>
        <v-btn icon @click="initialize"><v-icon>refresh</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-row justify="center">
      <v-col md="12" lg="10">
        <v-skeleton-loader v-if="loading" type="card-heading, image, article">
        </v-skeleton-loader>
        <div v-else>
          <v-card class="elevation-1" outlined>
            <v-tabs grow v-model="tabs">
              <v-tab :to="{ name: 'MaterialDetail', params: { id: this.id } }">
                Summary
              </v-tab>
              <v-tab :to="{ name: 'RawMaterials', params: { id: this.id } }">
                Raw Materials
              </v-tab>
              <v-tab :to="{ name: 'MaterialQuality', params: { id: this.id } }">
                Quality
              </v-tab>
              <v-tab :to="{ name: 'MaterialBatches', params: { id: this.id } }">
                Batches
              </v-tab>
              <v-tab
                :to="{ name: 'MaterialAttachments', params: { id: this.id } }"
              >
                Attachments
              </v-tab>
            </v-tabs>
            <v-card-text>
              <router-view :material="material"/>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { handleJSON } from "../../services/jsonDownload";
import Material from "../../models/Material";
import MaterialForm from "../../components/Material/MaterialForm";
import ArchiveForm from "../../components/State/ArchiveForm";
export default {
  name: "Material",
  components: {
    ArchiveForm,
    MaterialForm
  },
  data() {
    return {
      id: this.$route.params.id,
      loading: true,
      tabs: null
    };
  },
  computed: {
    material() {
      return Material.query()
        .withAllRecursive()
        .find(parseInt(this.id));
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      Material
        .$get(this.id)
        .then(() => (this.loading = false)
      );
    },
    saveJson() {
      handleJSON(this.material);
    }
  }
};
</script>
